var uncurryThis = require('../internals/function-uncurry-this');

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/uid.js
// module id = 179
// module chunks = 0